// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { calculateHierarchyTree } from './utils';
export function useColumnGroups(columnDefinitions, visibleColumns, groupDefinitions, columnDisplay) {
    const layout = calculateHierarchyTree(columnDefinitions, visibleColumns, groupDefinitions !== null && groupDefinitions !== void 0 ? groupDefinitions : [], columnDisplay);
    let groupColumnMap;
    if (layout.rows.length > 1) {
        groupColumnMap = new Map();
        const columnsRow = layout.rows[layout.rows.length - 1];
        for (const row of layout.rows) {
            for (const col of row.columns) {
                if (col.isGroup) {
                    const childColumnIds = columnsRow.columns
                        .filter(l => !l.isGroup && l.parentGroupIds.includes(col.id))
                        .map(l => l.id);
                    groupColumnMap.set(col.id, childColumnIds);
                }
            }
        }
    }
    return { ...layout, groupColumnMap };
}
//# sourceMappingURL=use-column-groups.js.map